import { Injectable } from '@angular/core';
import { IToken } from '@shared/interfaces/token.interface';
import { IUser } from '@shared/interfaces/user.interface';
import { UserModel } from '@shared/models/user.model';
@Injectable()
export class StorageService {
  public removeAll() {
    this.removeAccessToken();
    this.removeUserInfo();
    this.removeProfileInfo();
    localStorage.removeItem('SelectedDateRange');
  }

  public removeAllWithoutDevice() {
    this.removeAccessToken();
    this.removeUserInfo();
    this.removeProfileInfo();
  }

  public setClientAccessToken(value: IToken) {
    localStorage.setItem('ClientAccessToken', JSON.stringify(value));
  }

  public removeClientAccessToken() {
    localStorage.removeItem('ClientAccessToken');
  }

  public getClientAccessToken(): IToken {
    return JSON.parse(localStorage.getItem('ClientAccessToken') || '{}');
  }

  public setAccessToken(value: IToken) {
    document.cookie = 'isloggedin=true;path=/;domain=.hadsup.com';
    localStorage.setItem('AccessToken', JSON.stringify(value));
  }

  public removeAccessToken() {
    document.cookie = 'isloggedin=false;path=/;domain=.hadsup.com';
    localStorage.removeItem('AccessToken');
  }

  public getAccessToken(): IToken {
    return JSON.parse(localStorage.getItem('AccessToken') || '{}');
  }

  public setUserInfo(value: UserModel) {
    localStorage.setItem('User', JSON.stringify(value));
  }

  public removeUserInfo() {
    localStorage.removeItem('User');
  }

  public getUserInfo(): UserModel {
    return JSON.parse(localStorage.getItem('User') || '{}');
  }

  public setProfileInfo(value: IUser) {
    localStorage.setItem('Profile', JSON.stringify(value));
  }

  public removeProfileInfo() {
    localStorage.removeItem('Profile');
  }

  public getProfileInfo(): IUser {
    return JSON.parse(localStorage.getItem('Profile') || '{}');
  }

  public setCampaign(campaign: any) {
    localStorage.setItem('Campaign', JSON.stringify(campaign));
  }

  public setCampaignReview(campaign: any) {
    localStorage.setItem('CampaignReview', JSON.stringify(campaign));
  }
}
